import React, { Component } from 'react';

class GenreList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      genres, noInfoMessage
    } = this.props;
    if (!genres || genres.length === 0) {
      return (
        <span>
          {noInfoMessage}
        </span>
      );
    }
    const sortedGenres = [...genres].sort((a, b) => {
      if (a < b) { return -1; }
      if (a > b) { return 1; }
      return 0;
    });
    return sortedGenres.map(genre => (
      <span
        key={genre}
        className='br-chip'
      >
        {genre}
      </span>
    ));
  }
}

export default GenreList;
